module.exports = __webpack_public_path__ + "static/media/popup-framing.9e4d5eef.png";